/**
 * Shared normalization utilities for filter modules.
 * Handles nullable/undefined values from GraphQL API.
 *
 * These utilities accept GraphQL InputMaybe types directly:
 * - InputMaybe<Array<InputMaybe<T>>> → T[]
 */

/** GraphQL nullable array type - accepts InputMaybe<Array<InputMaybe<T>>> */
type NullableArray<T> = Array<T | null | undefined> | null | undefined;

export function normalizeNumberArray(input: NullableArray<number>): number[] {
  if (!input) return [];
  return input.filter((v): v is number => typeof v === "number");
}

export function normalizeStringArray(input: NullableArray<string>): string[] {
  if (!input) return [];
  return input.filter(
    (v): v is string => typeof v === "string" && v.length > 0
  );
}

export function normalizeMinMax(
  input?: { min?: number | null; max?: number | null } | null
): { min?: number; max?: number } | undefined {
  if (!input) return undefined;
  const min = typeof input.min === "number" ? input.min : undefined;
  const max = typeof input.max === "number" ? input.max : undefined;
  if (min === undefined && max === undefined) return undefined;
  return { min, max };
}
